module.exports = __webpack_public_path__ + "static/logo_fondo_cultura_2020-271ea76f731f9182f8f1da2ae9466493.jpg";